module.exports = __webpack_public_path__ + "fonts/remixicon.5ab3a2a4.woff2";